import React from 'react';
import { Toast, Container } from 'react-bootstrap';
import { CheckCircle, ExclamationTriangle, XCircle, X } from 'react-bootstrap-icons';

function ToastDynamic({ show=false, content=null, handleCloseToast, variant='success', toastClasses={ container: '', toast: '', body: '' } }) {
  
  const getColor = () => {
    switch(variant) {
      case 'success':
        return 'green';
      case 'error':
        return 'red';
      case 'warning':
        return 'yellow';
      default:
        return 'green';
    }
  };

  const getIcon = () => {
    switch(variant) {
      case 'success':
        return <CheckCircle className="toast-icon" />;
      case 'error':
        return <XCircle className="toast-icon" />;
      case 'warning':
        return <ExclamationTriangle className="toast-icon" />;
      default:
        return <CheckCircle className="toast-icon" />;
    }
  };

  const getVariantClass = () => {
    return `toast-${variant}`;
  };

  const effectiveColor = getColor();

  return (
    show && content ?
      <Container position='bottom-end' className={`toast-container toast-dynamic__color--${effectiveColor} ${toastClasses && toastClasses.container ? toastClasses.container : ''}`}>
        <Toast show={show} onClose={handleCloseToast} className={`${getVariantClass()} ${toastClasses && toastClasses.toast ? toastClasses.toast : ''} toast-dynamic__color--${effectiveColor}`}>
          <Toast.Body className="d-flex align-items-center">
            {getIcon()}
            <div className={`toast-content ${toastClasses && toastClasses.body ? toastClasses.body : ''}`}>{content}</div>
            <X className="toast-close-icon" onClick={handleCloseToast} />
          </Toast.Body>
        </Toast>
      </Container>
    : null
  )
}

export default ToastDynamic